import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, errorText, fmtTime } from "@/lib/api";

export const AccountsPanel = () => {
  const [accounts, setAccounts] = useState([]);

  const load = () => api.get("/admin/accounts").then((r) => setAccounts(r.data)).catch((e) => toast.error(errorText(e)));
  useEffect(() => { load(); }, []);

  const toggle = async (a, active) => {
    try {
      await api.post(`/admin/accounts/${a.id}/status`, { active });
      toast.success(`${a.email} ${active ? "turned on" : "turned off"}`);
      load();
    } catch (e) { toast.error(errorText(e)); }
  };

  return (
    <section className="space-y-4">
      <p className="text-sm text-slate-400">Everyone who has signed up. Turning an account off blocks sign-in and stops its devices and snippets from logging.</p>
      <div className="rounded-md border border-[#222D3D] bg-[#0F141C] overflow-x-auto" data-testid="accounts-table">
        <Table>
          <TableHeader>
            <TableRow className="border-[#222D3D] hover:bg-transparent">
              {["Account", "Joined", "Arrivals", "Devices", "Anchors", "Active"].map((h) => (
                <TableHead key={h} className="text-[11px] uppercase tracking-[0.14em] text-slate-500">{h}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {accounts.map((a) => (
              <TableRow key={a.id} className="border-[#222D3D] hover:bg-[#141A24]" data-testid={`account-row-${a.email}`}>
                <TableCell>
                  <p className="text-slate-100">{a.name}{a.role === "admin" && <span className="ml-2 font-mono text-[10px] text-emerald-400">owner</span>}</p>
                  <p className="text-xs text-slate-500">{[a.company, a.email].filter(Boolean).join(" · ")}</p>
                </TableCell>
                <TableCell className="font-mono text-xs text-slate-400 whitespace-nowrap">{fmtTime(a.created_at)}</TableCell>
                <TableCell className="font-mono text-sm">{a.entries}</TableCell>
                <TableCell className="font-mono text-sm">{a.devices}</TableCell>
                <TableCell className="font-mono text-sm">{a.anchors}</TableCell>
                <TableCell>
                  <Switch checked={a.active} disabled={a.role === "admin"} onCheckedChange={(v) => toggle(a, v)} data-testid={`account-active-switch-${a.email}`} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
